// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2Q5Bc","unreadBadge":"styles_unreadBadge__1V8rC","modalContent":"styles_modalContent__WfJRa","modal":"styles_modal__3ta1l"};